import React, { useState, useEffect } from "react";

import useRedux from "hooks/useRedux";

import * as actionsGroupList from "./portfolioEntry.duck";

import * as shoppingCartActionsGroupList from "../shoppingCart/shoppingCart.duck";

import { Divider, Button } from "@material-ui/core";

import * as BeforeYouStart from "./components/BeforeYouStart";
import * as Benchmarks from "./components/Benchmarks";
import * as AdditionalBenchmarks from "./components/AdditionalBenchmarks";
import * as Checkout from "./components/CheckoutOptions";
// import * as AnalysisType from "./components/AnalysisType";
import * as PortfolioName from "./components/PortfolioName";
import * as PortfolioDates from "./components/PortfolioDates";
import * as ImportValues from "./components/ImportValuesSection";

import * as PortfolioValuesNew from "./components/PortfolioValuesNew";
import * as PortfolioContributionsWithdrawals from "./components/PortfolioContributionsWithdrawals";

import * as ReportPreview from "./components/ReportPreview";

import Heading from "../home/components/Heading";
import styled from "styled-components";
import { openConfirm } from "../components/confirmBox/ConfirmBox";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

const Row = styled.div`
  display: flex;
  height: 100%;
`;

const Menu = styled.div`
  background-color: #e0e0e0;
  height: 100%;
  width: 250px;
  min-width: 250px;
  // padding: 30px;
  // padding-top: 50px;
`;

const MenuListItem = styled.div`
  margin-bottom: 10px;
  font-size: 16px;
  color: ${(props) => (!props.disabled ? "#3e51b5" : "#949494")};
  cursor: ${(props) => (!props.disabled ? "pointer" : "inherit")};
  font-weight: ${(props) => (props.selected ? "bold" : "inherit")};
  display: flex;
`;

const Content = styled.div`
  height: 100%;
  // padding: 20px;
  width: 100%;
  overflow: auto;
  // max-width:1000px;
`;

const ErrorItem = styled.div`
  border: 1px solid #ffbebe;
  background-color: #ffefef;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  margin-top: 10px;
`;

const ResetButton = styled.div`
  margin-left: 20px;
  color: #3e51b5;
  font-weight: bold;
  margin-top: 30px;
  cursor: pointer;
`;

const menuItems = [
  {
    title: "Before You Start",
    Component: BeforeYouStart,
  },
  {
    title: "Portfolio Name",
    Component: PortfolioName,
  },
  {
    title: "Import from Excel®",
    Component: ImportValues,
    onCompleteSkip: 1,
  },
  {
    title: "Analysis Period",
    Component: PortfolioDates,
  },
  {
    title: "Portfolio Closing Values",
    Component: PortfolioValuesNew,
  },
  {
    title: "Contributions, Withdrawals, and Fees",
    Component: PortfolioContributionsWithdrawals,
  },
  // {
  //     title: 'Portfolio Values',
  //     Component: PortfolioValues
  // },
  {
    title: "Benchmark Data",
    Component: Benchmarks,
  },
  {
    title: "Additional Benchmarks",
    Component: AdditionalBenchmarks,
  },
  {
    title: "Analysis Preview",
    Component: ReportPreview,
  },
  {
    title: "Review/Checkout",
    Component: Checkout,
  },
];

const Render = (props) => {
  const { Step, onCompleted = () => {} } = props;

  const errors = Step.Component.getErrors
    ? Step.Component.getErrors(props)
    : [];

  return (
    <div>
      <style>
        {`
          li{
            margin-bottom:5px;
          }
        `}
      </style>
      {Step.Component.Description && (
        <div style={{ color: "#797878", marginBottom: 40, maxWidth: 1000 }}>
          {Step.Component.Description(props)}
        </div>
      )}
      <Step.Component.Render
        {...{
          ...props,
          onCompleted: () => {
            if (Step.onCompleteSkip) {
              onCompleted(Step.onCompleteSkip);
            }
            // isCurrent && stepNumber_set(stepNumber + skip);
          },
        }}
      />
      {errors.length > 0 && (
        <ErrorItem>
          {/* <div>There are some issues that must be resolved before you can continue.</div> */}
          <ul>
            {errors.map((e, i) => (
              <li key={`err_${i}`}>{e}</li>
            ))}
          </ul>
        </ErrorItem>
      )}
    </div>
  );
};

const Main = (props) => {
  const { match = {} } = props;

  const [state, actions, shoppingCartActions] = useRedux(
    actionsGroupList,
    shoppingCartActionsGroupList
  );

  const portfolioEntry = state.portfolioEntry;
  const userManager = state.userManager;
  const shoppingCart = state.shoppingCart;

  const { params = { mode: "" } } = match;

  const [selectedItem, selectedItem_set] = useState(0);

  var portfolio = JSON.parse(JSON.stringify(portfolioEntry.portfolios[0]));

  useEffect(() => {
    if (params.mode && params.mode.toLowerCase() === "edit") {
      if (params.id) {
        if (shoppingCart && shoppingCart.cart && shoppingCart.cart.portfolios) {
          var found = shoppingCart.cart.portfolios.find(
            (e) => e.id === params.id
          );

          if (found) {
            portfolio = JSON.parse(JSON.stringify(found));
            actions.setActivePortfolio(portfolio);
          }
        }
      }
    } else {
      actions.resetPortfolio();
    }
  }, []);

  useEffect(() => {
    if (portfolio.currencyType) {
      actions.loadDatabaseDates(portfolio.currencyType);
    }
  }, [portfolio.currencyType]);

  menuItems.forEach((mi, index) => {
    mi.isComplete = mi.Component.isComplete
      ? mi.Component.isComplete({ ...props, portfolio })
      : false;
    mi.enabled =
      index === 0 ||
      (menuItems[index - 1].isComplete && menuItems[index - 1].enabled);
  });

  return (
    <div>
      <Heading {...props} />
      <Page>
        <Row>
          <Menu>
            <div style={{ margin: "50px 20px 20px 20px" }}>
              {menuItems.map((item, index) => (
                <MenuListItem
                  key={`mi_${index}`}
                  disabled={!item.enabled}
                  selected={selectedItem === index}
                  onClick={() => {
                    item.enabled && selectedItem_set(index);
                  }}
                >
                  <div style={{ marginRight: 5 }}>{index + 1}.</div>
                  <div>{item.title}</div>
                </MenuListItem>
              ))}
            </div>
            <ResetButton
              onClick={() => {
                openConfirm({
                  description: (
                    <div>
                      <p>
                        Any data you have entered for this portfolio will be
                        lost.
                      </p>
                      <p>Would you like to continue?</p>
                    </div>
                  ),
                  callback: () => {
                    actions.resetPortfolio();
                    selectedItem_set(0);
                  },
                });
              }}
            >
              Reset Data
            </ResetButton>
          </Menu>
          <Content>
            <div style={{ margin: 20, maxWidth: 1000 }}>
              <Render
                Step={menuItems[selectedItem]}
                {...{
                  portfolioEntry,
                  actions,
                  shoppingCartActions,
                  shoppingCart,
                  userManager,
                  portfolio,
                  onReset: () => {
                    selectedItem_set(0);
                  },
                }}
                onCompleted={(skip) => {
                  if (skip) {
                    selectedItem_set(selectedItem + skip);
                  }
                }}
              />
              <Divider style={{ marginTop: 20 }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <div style={{ margin: 10 }}>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    style={{ width: 100 }}
                    disabled={selectedItem === 0}
                    onClick={() => {
                      selectedItem_set(selectedItem - 1);
                    }}
                  >
                    Previous
                  </Button>
                </div>
                <div style={{ margin: 10 }}>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    style={{ width: 100 }}
                    disabled={
                      selectedItem === menuItems.length - 1 ||
                      !menuItems[selectedItem].isComplete
                    }
                    onClick={() => {
                      selectedItem_set(selectedItem + 1);
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </Row>
      </Page>
      {/* <Footer {...props} /> */}
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/Main.js